// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Location: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 27" stroke="currentColor">
            <g fill="none" fillRule="evenodd">
                <path d="M17.614 16.933c1.32-1.873 2.359-3.877 2.359-6.274 0-5.23-4.244-9.463-9.49-9.463C5.244 1.196 1 5.43 1 10.659c0 3.103 1.583 5.238 3.382 7.595l6.006 7.872c.107.14 2.09-2.5 2.256-2.712.76-.972 1.51-1.95 2.253-2.934.887-1.175 1.86-2.333 2.717-3.547Z" />
                <path d="M14.845 10.431c0 2.55-1.952 4.618-4.359 4.618S6.128 12.98 6.128 10.43c0-2.55 1.951-4.618 4.358-4.618 2.407 0 4.359 2.068 4.359 4.618Z" />
            </g>
        </svg>
    );
};

export default React.memo(Location);
